export const classes = {
  paper:
    'rounded-[22px] border border-solid border-white/[0.72] bg-none bg-[#FEFDFE] shadow-glass dark:border-white/[0.14] dark:bg-[#332e43] dark:shadow-glass-dark',
  body: 'px-8',
};

export const styles = {
  backdrop: {
    backgroundColor: 'rgba(22,18,28,0.42)',
    backdropFilter: 'blur(2px)',
  },
};
